import React, { useEffect, useState } from "react";
import ReactHtmlParser from "../../../utils/parseHtml";
import { CheckJSONString } from "../../common/CheckJSONString";
import { formatQuestion } from "../../../utils/FormatQuestion";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { MathJax } from "better-react-mathjax";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { reorder } from "../../../utils/ReArrangeFunction";
import DropzonePlaceholder from '../../library/DropzonePlaceholder';

function OptionList({
  item,
  index,
  from,
  selectedOptionId
}) {
  return (
    <div className="">
      {/* que-custom-space */}
     {from == "viewAnswer" ? 
     <input
     type="radio"
     className="cursor-pointer"
     name="example"
     id={`customRadio_${item.q_option + index}`}
     checked={selectedOptionId && selectedOptionId?.UserChooseOptionId && selectedOptionId?.UserChooseOptionId == item?.oid}
     readOnly
   /> :
     <input
        type="radio"
        className="cursor-pointer"
        name="example"
        id={`customRadio_${item.q_option + index}`}
      />}

      <label className="ml-2 cursor-pointer" htmlFor={`customRadio_${item.q_option + index}`}>
        {(from == "addQuestion" || from == "duplicateQuestion" || from == "viewQuestion"
         ) ? item.q_option : from == "viewAnswer" ? ReactHtmlParser(item.q_option) : ReactHtmlParser(item.q_option)}
      </label>


      {/* {JSON.parse(item.q_option).blocks.length > 1 ?
        <div className="form-icon-group" title={CheckJSONString(item.q_option) ? formatQuestion(item.q_option) : ReactHtmlParser(
          `${index + 1}) ${item.q_option}`.replace(/<\/?[^>]+>/gi, "")
        )}>
          <figure className="upload-img-size">
            <img src={JSON.parse(item.q_option).entityMap["0"].data.src} alt={CheckJSONString(item.q_option) ? formatQuestion(item.q_option) : ReactHtmlParser(
              `${index + 1}) ${item.q_option}`.replace(/<\/?[^>]+>/gi, "")
            )} />
          </figure>
        </div> : ""} */}
    </div>
  );
}

function OptionListCheckbox({
  item,
  index,
  from,
  selectedOptionId
}) {
  return (
    <div className="custom-control custom-checkbox">
      {from == "viewAnswer" ? 
       <input
       className="custom-control-input"
       name="example"
       type="checkbox"
       id={`customCheck_${item.q_option + index}`}
       checked={selectedOptionId?.UserChooseOptionId?.find((id) => id == item?.oid ? true : false)}
       disabled
     /> 
      : <input
        className="custom-control-input"
        name="example"
        type="checkbox"
        id={`customCheck_${item.q_option + index}`}
      />}

      <label className="custom-control-label" for={`customCheck_${item.q_option + index}`}>
        {(from == "addQuestion" || from == "duplicateQuestion" || from == "viewQuestion"
        // || from == "assignedQTable"
        ) ? item.q_option : from == "viewAnswer" ? ReactHtmlParser(item.q_option) : ReactHtmlParser(item.q_option)}
        {/* {CheckJSONString(item.q_option) ? formatQuestion(item.q_option) : ReactHtmlParser(
          `${index + 1}) ${item.q_option}`.replace(/<\/?[^>]+>/gi, "")
        )} */}
      </label>
      {/* {JSON.parse(item).blocks.length > 1 ? <img src={JSON.parse(item).entityMap["0"].data.src} alt="preec" /> : ""} */}
    </div>
  );
}


function OptionListMatch({from,question}){
  // let userResultStr = question?.answerData?.UserAnswer && question?.answerData?.UserAnswer?.split(",")[index].split("___")
  const [optionData, setOptionData] = useState([...question.options]); 
  const [optionHeights, setOptionHeights] = useState([]);

  const handleDragEnd = (result) =>{
    if(!result.destination){
      return
    }
    let dragData = [...optionData];
    dragData = reorder(dragData, result.source.index, result.destination.index);
    setOptionData([...dragData])
    setOptionHeights(oldVal => [...reorder(oldVal, result.source.index, result.destination.index)])
  }
  
  useEffect(() => {
    setTimeout(() => {
      let itemsHeight = []
      let optionsHeight = []
      let ulItems = document.getElementById("matchingItems")
      let ulOptions = document.getElementById("matchingOptions")
      if (ulItems) {
        let list = Array.from(ulItems.childNodes)
        list.map(li => {
          const height = li.offsetHeight
          itemsHeight.push(height)
        })
      }
      if (ulOptions) {
        let list = Array.from(ulOptions.childNodes)
        list.map(li => {
          const height = li.offsetHeight
          optionsHeight.push(height)
        })
      }
      setOptionHeights(fixHeightsArr(itemsHeight, optionsHeight))
    }, 500);
  }, [optionData])

  const fixHeightsArr = (arr1 = [], arr2 = []) => {
    let result = []
    arr1.forEach((item, index) => {
      if (item > arr2[index]) {
        result.push(item)
      } else {
        result.push(arr2[index])
      }
    })
    return result;
  }

  return (
    <div className="row">
      <div className="col-md-6"> 
        <ul className="list-unstyled view-match-column" id="matchingOptions">
          {question.options.map((item, ind) => {
            return (item.q_option ?
              <li key={ind} style={{ height: `${optionHeights[ind]}px` }}>
                {item.q_option ? (CheckJSONString(item.q_option) ? formatQuestion(item.q_option) : ReactHtmlParser(
                  `<span>${item.q_option}</span>`
                )) : null}
              </li>
              : null)
          })}     
        </ul>
      </div>
      <div className="col-md-6">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
          {(provided, snapshot) => {
            return (
              <div ref={provided.innerRef} {...provided.droppableProps}>
              <ul className="list-unstyled view-match-column-drag" id="matchingItems">              
                {optionData.map((item,ind)=>{
                  return (
                  <Draggable key={ind} draggableId={"drag"+ind} index={ind} isDragDisabled={from=='viewAnswer'}>
                    {(provided, snapshot)=>(
                        <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                          {/* 12px are margin and padding in li and height calculated is of li thats why div is adjusted accordingly */}
                          <div style={{ height: `${optionHeights[ind] - 12}px` }}>
                            {from == "viewAnswer" ? (question?.answerData?.UserAnswer && question?.answerData?.UserAnswer?.split(",")[ind].split("___"))[1] : (item.q_option_match ? (CheckJSONString(item.q_option_match) ? formatQuestion(item.q_option_match) : ReactHtmlParser(
                              `<span>${item.q_option_match}</span>`
                            )) : null)}
                          </div>
                        </li>
                    )}
                  </Draggable>
                )})}     
              </ul>
            </div>
          )}}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
}


function OptionFillintheBlank(item, options){
  let userAnswers;
  if(options && options.UserAnswer && options.UserAnswer!=""){
    userAnswers = options.UserAnswer.split(",");    
  }
  const paragraph = item.replace( /(<([^>]+)>)/ig, '').replace(/\n|\r/g, "").trim()
  const words = paragraph.split(' ');
  let inputCount = -1;
  return (
    <div className="form-group">
      <div className="fillstyle">
      {words.map((word, index) => {
        if(word == "___" ){
          inputCount++;
        }
      return(
        <React.Fragment key={index}>
          {index !== 0 && ' '} {/* Add a space before each word except the first one */}
          {word !== "___" ? (
            <span style={{margin:"3px"}}>{word}</span>
          ) : (
            <input value={userAnswers && userAnswers[inputCount] ? userAnswers[inputCount]?.replace('["',"").replace('"]',"") : ""} className="form-control col-sm-2" type="text"/>
          )}
        </React.Fragment>
      )})}
    </div>
    </div>
  )
}

function OptionShortAnswer({from, item}) {
  return (
    <div className="form-group">
     { from == "viewAnswer" ? 
     <textarea
        type="text"
        className="form-control"
        disabled
      >{formatQuestion(item?.answerData?.UserAnswer)}</textarea>  :<textarea
        type="text"
        className="form-control"
        placeholder="Short Answer"
      ></textarea>
      }
    </div>
  );
}

function OptionLongAnswer({from, item}) {
  return (
    <div className="form-group">
     { from == "viewAnswer" ? 
     <textarea
        type="text"
        className="form-control"
        disabled
      >{formatQuestion(item?.answerData?.UserAnswer)}</textarea>  :<textarea
        type="text"
        className="form-control"
        placeholder="Long Answer"
      ></textarea>
      }
    </div>
  );
}

function OptionChoiceMatrix({from, item}){
  let userAnswer;
  
  if(from==="viewAnswer"){
    userAnswer = item?.answerData?.UserAnswer.map((ans) =>(ans.split("___")[1]));
  }
  
  let matrixArray = item.options.map((item, i) => {
    let tempObj = {
      titleValue: item.titleValue, 
      optionid: item.oid,
      rowTitle: item.titleValue, 
      options: item?.q_option ? 
                JSON.parse(item?.q_option).length ? 
                  JSON.parse(item?.q_option).map((ele, j) => {
                    return {
                      ...ele, 
                      text: ele?.titleValue,
                      isSelected : from==="viewAnswer" ? (ele?.titleValue==userAnswer[i]) : ele?.isSelected
                    }
                  }) : 
                [] : 
              []
    }    
    return tempObj;
  })
  return (
    <div className="view-matrix-table">
      <label className="ml-1">Option *</label>
      <table className="export-table-border-header">
          <thead>
              <tr>
                  <th></th>
                  {matrixArray?.length && matrixArray[0].options.map((option, index) => (
                      <th key={index}>{option.text}</th>
                  ))}
              </tr>
          </thead>
          <tbody>
              {matrixArray?.length && matrixArray.map((rowData, rowIndex) => (
                  <tr key={rowIndex}>
                      <td>{rowData?.rowTitle}</td>
                      {rowData?.options.map((option, optionIndex) => (
                          <td key={optionIndex}>
                              <div className="form-icon-group">
                                  <div
                                  >
                                      <input
                                          type="radio"
                                          className="cursor-pointer"
                                          name={`example${rowData?.optionid}`}
                                          readOnly={from==="viewAnswer"}  
                                          id={`customRadio${rowData?.optionid}`}                                       
                                          checked={from==="viewAnswer" ? option.isSelected : false}
                                      />
                                  </div>
                              </div>
                          </td>
                      ))}
                  </tr>
              ))}
          </tbody>
      </table>
    </div>
  )
}
const DocumentUploadPreview = () => {
  return (
    <DropzonePlaceholder accept=".zip,.jpg,.png,.jpeg,.pdf,.doc,.docx,.txt,.mp4,.mp3,.otf">
      <i className="fas fa-file-upload"></i>
      <h4>
        To submit question, Drop your file here, or <span>browse</span>
      </h4>
      <p>Supports: PDF, DOCX and more</p>
    </DropzonePlaceholder>
  )
}

const imgAndText = (data, ques, options) => {
  // let tempState = EditorState.createWithContent(convertFromRaw(JSON.parse(data)));
  // const forFormik = draftToHtml(
  //   convertToRaw(tempState.getCurrentContent())
  // );
  // return ReactHtmlParser(forFormik)
  let generalNote = CheckJSONString(data);
  if (generalNote) {
    const blocksFromHTML2 = convertFromRaw(JSON.parse(data));
    let dataDescr = EditorState.createWithContent(blocksFromHTML2);
    const note = draftToHtml(convertToRaw(dataDescr.getCurrentContent()));
    return note ? note : "<p><p/>"

  }
  else {
   if(ques == "Fill in the blank"){
     return OptionFillintheBlank(data,options)
   } else{
     return data
   }
  }


  // return ReactHtmlParser(data)
}

const OrderListPreview = ({from, item}) =>{
  const userAnswers = from=="viewAnswer" && item?.answerData?.UserAnswer ? item?.answerData?.UserAnswer?.split(",").map(item => item.split("___")[1]) : null;
  const [optionData, setOptionData] = useState([...item.options]);  
  const handleDragEnd = (result) =>{
    if(!result.destination){
      return
    }
    let dragData = [...optionData];
    dragData = reorder(dragData, result.source.index, result.destination.index);
    setOptionData([...dragData])
  }

  return (
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot)=>(
            <div className="order-list-wrapper" ref={provided.innerRef} {...provided.droppableProps}>
              {optionData.map((opt, idx)=>(
                <Draggable key={idx} draggableId={"drag"+idx} index={idx} isDragDisabled={from=='viewAnswer'}>
                  {(provided, snapshot)=>(
                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="order-list-item">
                      {from=="viewAnswer" && userAnswers && userAnswers.length>0 ? ReactHtmlParser(userAnswers[idx]) : ReactHtmlParser(opt.q_option)}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
  )
}

function DisplayQuestion(props) {
  const { question, from } = props;
  return (
    <div>
      {Object.keys(question).length > 0 && (
        <div className="card-quiz card-header-dark">
          <div className="">
            <div className="form-group">
              <div className="row ml-0 mr-0">
                <label className="d-block">
                  <strong>
                    {/* {CheckJSONString(question.question) ? formatQuestion(question.question) : ReactHtmlParser(question.question)} */}
                    <MathJax> 
                    {question.question !== null && question.question_type != "Fill in the blank" ? imgAndText(question.question):  imgAndText(question.question, "Fill in the blank", question.answerData)}
                    {/* {question.question !== null &&  imgAndText(question.question)} */}
                    </MathJax>
                  </strong>
                  {/* <p className="">
                    {question.description !== null && imgAndText(question.description)}
                    custom-des-space
                    mt-1 
                    {CheckJSONString(question.description) ? formatQuestion(question.description) : ReactHtmlParser(
                      question.description.replace(/<\/?[^>]+>/gi, "")
                    )}
                  </p> */}
                </label>  
              </div>
              <div className="row ml-0 mr-0">
                <label className="d-block">
                  {/* <strong>
                    {CheckJSONString(question.question) ? formatQuestion(question.question) : ReactHtmlParser(question.question)}
                    {question.question !== null && imgAndText(question.question)}
                  </strong> */}
                  <MathJax>
                  <p className="">
                    {/* custom-des-space */}
                    {/* mt-1  */}
                    {question.description !== null && imgAndText(question.description)}
                    {/* {CheckJSONString(question.description) ? formatQuestion(question.description) : ReactHtmlParser(
                      question.description.replace(/<\/?[^>]+>/gi, "")
                    )} */}
                  </p>
                  </MathJax>
                </label>
              </div>
              <div className={(question.question_type == "Multiple Choice Single Answer" || question.question_type == "Multiple Choice Multiple Answer") ? "row ml-0 mr-0" : ""}>
              <div className="radio-group-custom">
                {/* Multiple Choice Single Answer */}
                {question.question_type == "Multiple Choice Single Answer" &&
                  question.options.map((item, index) => (
                    <MathJax>
                    <OptionList
                      item={item}
                      index={index}
                      key={index}
                      from={from}
                      selectedOptionId={question.answerData}
                    />
                    </MathJax>
                  ))}
                {/* Multiple Choice Multiple Answer */}
                {question.question_type == "Multiple Choice Multiple Answer" &&
                  question.options.map((item, index) => (
                    <MathJax>
                    <OptionListCheckbox
                      item={item}
                      index={index}
                      from={from}
                      selectedOptionId={question.answerData}
                    />
                    </MathJax>
                  ))}
                {/* Match the Column */}
                {(question.question_type == "Match the Column" || question.question_type == "Match The Column") && (                  
                    <MathJax>
                      <OptionListMatch
                        question={question}
                        from={from}
                      />
                    </MathJax>
                )}
                {/* Short Answer */}
                {question.question_type == "Short Answer" && (
                  <MathJax>
                    <OptionShortAnswer from={from} item={question}/>
                  </MathJax>
                  )}
                {/* Long Answer */}
                {question.question_type == "Long Answer" && (
                   <MathJax>
                  <OptionLongAnswer from={from} item={question}/>
                  </MathJax>
                )}
                {/* Choice Matrix */}
                {question.question_type == "Choice Matrix" && (
                  <MathJax>
                    <OptionChoiceMatrix from={from} item={question} />
                  </MathJax>
                )}
                {/* Document Upload */}
                {question.question_type == "Document Upload" &&(
                  <DocumentUploadPreview />
                )}
                {/* Order List */}
                {question.question_type == "Order List" &&(
                  <OrderListPreview from={from} item={question} />
                )}
                {(question.question_type == "Document Upload" || question.question_type == "Long Answer" || question.question_type == "Evidence Only") && (
                  <>
                  {(question?.evidence_photo || question?.evidence_video || question?.evidence_lecturer_observation) ? <div className='font14semi my-4'>Evidence Required</div> : null}
                  <div className='evidence-row'>
                    {question?.evidence_photo ?<div> <i className='fas fa-times-circle text-danger'></i> <i className='fal fa-camera mx-1'></i>Photo</div> : null}
                    {question?.evidence_video ?<div> <i className='fas fa-times-circle text-danger'></i> <i className='fal fa-video mx-1'></i>Video</div> : null}
                    {question?.evidence_lecturer_observation ? <div><i className='fas fa-times-circle lect-icon'></i><i className='fal fa-user-check mx-1'></i>Lecturer Observation</div> : null}
                  </div>
                      <div className="row">
                        {question?.evidence_photo ? <div className='col-lg-6 d-flex flex-column'>
                          <div className='f-bold headingPermission'><i className='fal fa-camera'></i> Photo Evidence</div>
                          <div className="form-group atttach-file mt-2 mb-3">
                            <form>
                              <label>
                                <i className={`fal fa-paperclip`}></i>
                                <span>Add Attachment</span>
                                <input
                                  type="file"
                                  className="form-control form-control-aatch-file cursor-auto"
                                  disabled={true}
                                  accept='.jpg, .png, .jpeg'
                                />
                              </label>
                            </form>
                          </div>
                        </div> : null}
                        {question?.evidence_video ? <div className='col-lg-6 d-flex flex-column'>
                          <div className='f-bold headingPermission'><i className='fal fa-camera'></i> Video Evidence</div>
                          <div className="form-group atttach-file mt-2 mb-3">
                            <form>
                              <label>
                                <i className={`fal fa-paperclip`}></i>
                                <span>Add Attachment</span>
                                <input
                                  type="file"
                                  className="form-control form-control-aatch-file cursor-auto"
                                  disabled={true}
                                  accept='.jpg, .png, .jpeg'
                                />
                              </label>
                            </form>
                          </div>
                        </div> : null}
                      </div>
                  </>
                )}
              </div>
                </div>
            </div>
          </div>
        </div>
      )}
    </div>
    
  );
}

export default DisplayQuestion;
